import { ChevronLeft } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const listItems = [
  { title: "Article" },
  { title: "Book" },
  { title: "Chapter" },
  { title: "Code" },
  { title: "Journal" },
  { title: "Conference" },
  { title: "Cover Page" },
  { title: "Data" },
  { title: "Experiment Findings" },
  { title: "Method" },
  { title: "Negative Results" },
  { title: "Patent" },
  { title: "Poster" },
  { title: "Preprint" },
  { title: "Presentation" },
  { title: "Raw Data" },
  { title: "Research Proposal" },
  { title: "Report" },
  { title: "Thesis" },
];

const PublishedResearchSidebar = ({ onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="dropdown-overlay" onClick={onClose}>
      <div
        className="dropdown nested-sidebar"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="user-icon-name">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            <ChevronLeft />
            <h3>Go back</h3>
          </div>
          <button className="close-dropdown-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="link-list">
          {listItems.map((item, index) => (
            <div
              className="list-item"
              key={index}
              onClick={() => {
                // navigate(`/upload-research?type=${item.title.toLowerCase()}`);
                navigate("/publish/journal");
                onClose();
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="list-title">
                <h3>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublishedResearchSidebar;
